<template>
  <div class="completion">
    <header>
      <h3>需求完成情况</h3>
      <span>(期望交付 / 制作完成时间)</span>
    </header>
    <div ref="target" style="width: 100%; height: 400px" v-loading="loading"></div>
  </div>
</template>
<script>
import { debounce } from "lodash"
import * as echarts from "echarts"
import API from "@/api/workOrder/board.js"
import { mapState } from "vuex"
export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      myChart: null,
      dashOffset: 0,
      // 追踪是否是首次渲染，只在首次显示虚线tooltip
      isFirstRender: true,
      lineData:[]
    }
  },
  computed: {
    ...mapState({
      sidebarOpened: (state) => state.app.sidebar.opened,
    }),
  },
  watch: {
    form: {
      handler: debounce(function (newVal, oldVal) {
        this.loading = true
        let params = {
          ...this.form,
          range_time: this.form.range_time?.length>0?this.form?.range_time.join("/"):"",
        }
        API.getDemandCompletion(params).then((res) => {
          if (res.code === 200) {
            this.loading = false
            this.lineData = res.data
            this.myChart = echarts.init(this.$refs.target)
            // 初始化时设置一个随机的dashOffset，确保虚线一开始就是完整的
            this.dashOffset = Math.random() * 15
            this.renderChart()
            window.addEventListener("resize", this.handleResize)

            // 添加鼠标移出图表事件监听，当鼠标离开图表时重新显示虚线tooltip
            this.$refs.target.addEventListener(
              "mouseleave",
              this.handleMouseLeave
            )
            
          }
        })
      },500),
      deep: true,
      immediate: true,
    },
    // 监听侧边栏状态变化，重新渲染图表
    sidebarOpened() {
      this.renderChart()
      setTimeout(() => {
        if (this.myChart) {
          this.handleResize()
        }
      }, 200)
    },
  },
  mounted() {},

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    // 移除鼠标移出事件监听
    this.$refs.target.removeEventListener("mouseleave", this.handleMouseLeave)
    this.myChart && this.myChart.dispose()
  },

  methods: {
    

    // 格式化日期为YYYY-MM-DD格式
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1)
      const day = String(date.getDate())
      return `${month}/${day}`
    },

    renderChart() {
      // 获取前22天和后7天的日期
      const dates = this.lineData.map(item=>item.date) 
      const planData = this.lineData.map(item=>item.demand_num)
      const actualData = this.lineData.map(item=>item.upload_material_num)

      // 找到当前日期在数组中的索引作为关键点
      const today = this.formatDate(new Date())
      console.log(today,'-----');
      
      const keyDateIndex = dates.findIndex((date) => date === today)

      // 如果找不到今天的日期（这不应该发生），使用数组中间位置作为默认值
      const safeKeyDateIndex =
        keyDateIndex !== -1 ? keyDateIndex : Math.floor(dates.length / 2)

      const options = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          borderColor: "rgba(0, 0, 0, 0.7)",
          textStyle: {
            color: "#fff",
          },
          // 使用箭头函数保留Vue实例的this上下文
          formatter: (params) => {
            // 确保params[0]存在
            if (!params || params.length === 0) return '';
            
            let result = params[0].name + "<br/>";
            // 过滤掉没有名称或值为null的系列
            params.forEach((param) => {
              if (param.seriesName && param.value !== null) {
                result += param.marker + param.seriesName + ": " + param.value + "<br/>";
              }
            });

            return result;
          },
          // 使用默认的鼠标触发行为
          showContent: true,
          triggerOn: "mousemove|click",
          // 允许用户交互时自动跟随鼠标
          alwaysShowContent: false,
        },
        legend: {
          data: ["计划完成量", "实际完成量"],
          textStyle: {
            color: "#333",
          },
          top: 30,
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dates,
          axisLine: {
            lineStyle: {
              color: "#e8e8e8",
            },
          },
          axisLabel: {
            color: "#666",
            formatter: (value) => {
              // 格式化日期显示
              const date = new Date(value)
              return `${date.getMonth() + 1}/${date.getDate()}`
            },
          },
          // 配置x轴的axisPointer
          axisPointer: {
            type: "shadow",
            show: true,
            link: { xAxisIndex: "all" },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#e8e8e8",
            },
          },
          axisLabel: {
            color: "#666",
          },
          splitLine: {
            lineStyle: {
              color: "#f0f0f0",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "计划完成量",
            type: "line",
            data: planData,
            smooth: true,
            lineStyle: {
              color: "#5470c6",
              width: 2,
            },
            itemStyle: {
              color: "#5470c6",
            },
            symbolSize: 6,
          },
          {
            name: "实际完成量",
            type: "line",
            data: actualData,
            smooth: true,
            lineStyle: {
              color: "#91cc75",
              width: 2,
            },
            itemStyle: {
              color: "#91cc75",
            },
            symbolSize: 6,
          },
          // 独立的垂直线系列，用于显示今日标记
          {
            name: '',
            type: 'line',
            // 使用空数据只显示标记线
            data: [],
            // 隐藏该系列的图例项
            showSymbol: false,
            lineStyle: {
              opacity: 0
            },
            // 禁止该系列显示tooltip
            tooltip: {
              show: false
            },
            markLine: {
              silent: true,
              data: [
                {
                  xAxis: dates[safeKeyDateIndex],
                  lineStyle: {
                    color: "#ed766f",
                    type: "dashed",
                    width: 2,
                    // 添加虚线动态效果的配置
                    shadowBlur: 10,
                    shadowColor: "#ed766f",
                    // 使用动态的dashOffset
                    dashOffset: this.dashOffset,
                    // 自定义虚线图案，更适合流动效果
                    dashArray: [8, 4],
                  },
                  label: {
                    show: true,
                    formatter: "今\n日",
                    rotate: 0,
                    position: "insideStartTop",
                    distance: [-30, 0],
                    color: "#ed766f",
                    fontSize: 14,
                    fontWeight: "bold",
                    padding: 5,
                    // 为标签也添加动画
                    animation: true,
                    animationDuration: 2000,
                    animationEasing: "cubicInOut",
                    animationDelay: function (idx) {
                      return idx * 100
                    },
                  },
                  // 添加动画效果
                  animation: true,
                  animationDuration: 2000,
                  animationEasing: "linear",
                  animationDelay: function (idx) {
                    return idx * 100
                  },
                  animationLoop: true,
                  // 通过回调函数实现动态虚线效果
                  animationDelayUpdate: function (idx) {
                    return idx * 5
                  },
                },
              ],
            },
            // 这个系列不会显示在图例中，也不受图例选择状态影响
            legendHoverLink: false
          },
        ],
      }
      this.myChart && this.myChart.setOption(options)

      // 仅在首次渲染时显示虚线附近的tooltip
      if (this.isFirstRender) {
        setTimeout(() => {
          this.myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0, // 使用实际数据系列的索引
            dataIndex: safeKeyDateIndex,
          })
          // 标记为已首次渲染
          this.isFirstRender = false
        }, 100)
      }
    },

    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
        // 调整大小后，延迟显示虚线tooltip，确保DOM更新完成
        setTimeout(() => {
          this.showKeyDateTooltip()
        }, 100)
      }
    },

    // 处理鼠标移出图表事件
    handleMouseLeave() {
      this.showKeyDateTooltip()
    },

    // 显示虚线位置的tooltip
    showKeyDateTooltip() {
      if (this.myChart) {
        // 获取日期数组
        const dates =  this.lineData.map(item=>item.date)
        // 找到今天在数组中的索引作为关键点
        const today = this.formatDate(new Date())
        const keyDateIndex = dates.findIndex((date) => date === today)

        // 如果找不到今天的日期（这不应该发生），使用数组中间位置作为默认值
        const safeKeyDateIndex =
          keyDateIndex !== -1 ? keyDateIndex : Math.floor(dates.length / 2)

        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0, // 使用实际数据系列的索引
          dataIndex: safeKeyDateIndex,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.completion {
  header {
    display: flex;
    align-items: center;
    span {
      color: #a9afb9;
      margin-left: 10px;
    }
  }
}
</style>
